module.exports = __webpack_public_path__ + "img/research_1.399dcfe1.png";